<template>
  <div id="cv-template">

    <SideBar
      :cvid="cv_id"
      v-on:show-prev="previewDialog=true; updateed  += 1"

    ></SideBar>

    <VtoolBarHome></VtoolBarHome>

    <v-content>
      <v-container grid-list-xl>

        <MenuDialer :cvid="cv_id"></MenuDialer>

        <v-layout justify-center row wrap>

          <v-flex xs12 lg10>

            <h4 class="headline ml-5 pl-5"> Veuillez choisir un modèle de cv pour <span class="font-weight-bold">{{ vuexCvModel.name }} </span>  </h4>
            <!-- <h4 class="headline"> Template actuel : {{ vuexCvModel.cv_template }}  </h4> -->

          </v-flex>

          <TemplateChoice
            :templateId="vuexCvModel.cv_template.id"
            v-on:selectTemplate="changeTemplate"
          >
          </TemplateChoice>

        </v-layout>

      </v-container>
    </v-content>
  </div>

</template>

<script>
 import VtoolBarHome from '../components/VtoolBarHome';
 import SideBar from '../components/SideBar';
 import MenuDialer from '../components/MenuDialer';
 import TemplateChoice from '../components/TemplateChoice';
 import { mapActions, mapGetters, mapState } from 'vuex';

 export default {

   data() {
     return {
       isLoading: false,
       previewDialog: false,
       updateed: 0,
     }
   },
   props: ['cv_id'],
   components: {
     VtoolBarHome,
     SideBar,
     TemplateChoice,
     MenuDialer,
   },
   methods: {
     goToCvPreview(cvId) {
       this.$router.push({ name: 'cvPreview', params: { cv_id:cvId } })
     },
     changeTemplate(templateID) {
       // Fonction Proxy qui appelle la fonction Vuex
       console.log('Template selectionné : ' + templateID)
       this.updateCvModelObject({ 'cvid': this.vuexCvModel.id,
                                  'data_sent': {'templates': [{ 'curriculum': this.vuexCvModel.id, 'template': templateID  }],  'cv_template': templateID } });
       // this.$router.go(-1)
       // this.$router.push({ name: 'cvEdit', params: { cv_id:this.cv_id} })
     },
     ...mapActions('cvVuex', [
       'getCvModelObject',
       'updateCvModelObject',
     ]),
   },
   computed: {
     ...mapState('cvVuex', [
       'vuexCvModel',
     ]),
   },
   mounted: function() {
     console.log('---- Mounted called Vuex getCvModelObject ----' )
     this.getCvModelObject({'cvid': this.cv_id});
   },
 }

</script>
